import { AnalyticEventCategory, AnalyticEventType, LoginProviderEnum } from '../../../../shared/entity_datas/EntityDatas.ts';
import { ColonistMembershipProduct } from '../../../../shared/store/ColonistMembershipProduct.ts';
import { PaymentMethod } from '../../../../shared/store/BaseColonistStoreProduct.ts';
import { ClientUserState } from '../ClientUserState.ts';
import { tabCommunication, uiManagerEvents } from '../EntryShared.ts';
import { isSubscriptionOverlayVariant } from '../store/subscription_overlay/subscriptionOverlayABTest.ts';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
import { TabCommunicationEvent } from '../tab_communication/TabCommunication.ts';
import { showSimpleDialog } from '../ui_popup/showSimpleDialog.ts';
import { showDeleteAccountDialog } from '../ui_popup/showDeleteAccountDialog.ts';
import { showChangeRegionDialog } from '../ui_popup/change_region_dialog/showChangeRegionDialog.ts';
import { StorageWrapper } from '../StorageWrapper.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { getHomepageUrl, navigateToPage } from '../ui_utils/ClientUtils.ts';
import { setElementOnClick, createImgIn, createLinkIn, createParagraphIn, setElementInnerHTML, createDivIn, createHeaderIn } from '../ui_utils/DomUtils.ts';
import { CA } from '../analytics/Analytics.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { UICheckoutAjaxEndPoints } from '../ui_checkout/UICheckoutAjaxEndPoints.ts';
import { getNestedTranslation } from '@colonist/i18n';
export class UIProfileSettingsController {
    initMembershipStatus() {
        var _ClientUserState_userState;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hasMembership()) {
            this.showMembershipTitleAndIcon();
            return;
        }
        this.showNotMemberTextAndBecomeMemberCTA();
    }
    showMembershipTitleAndIcon() {
        var _ClientUserState_userState, _ClientUserState_userState1, _ClientUserState_userState2;
        const currentMembership = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.getCurrentMembership();
        if (currentMembership == undefined) return;
        const currentMembershipProduct = ColonistMembershipProduct.getMembershipProduct(currentMembership.type);
        const textContainer = createDivIn(this.membershipStatusContainer, 'page-profile-settings-account-container', '');
        createImgIn(textContainer, currentMembership.image);
        const membershipTitleText = getNestedTranslation({
            key: 'strings:storePage.membership.body'
        }, {
            title: currentMembership.title,
            frequency: currentMembershipProduct.billedAnnually ? {
                key: 'strings:storePage.membership.frequency.annual'
            } : {
                key: 'strings:storePage.membership.frequency.monthly'
            }
        });
        createHeaderIn(textContainer, membershipTitleText, '', '', 'H3');
        const canManage = ((_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.items.membershipPaymentMethod) == PaymentMethod.Stripe || ((_ClientUserState_userState2 = ClientUserState.userState) === null || _ClientUserState_userState2 === void 0 ? void 0 : _ClientUserState_userState2.items.membershipPaymentMethod) == PaymentMethod.Discord;
        if (canManage) {
            const membershipManageButton = createDivIn(this.membershipStatusContainer, 'page-profile-settings-account-button disconnect');
            setElementInnerHTML(membershipManageButton, {
                key: 'strings:storePage.sections.membership.action.manage'
            });
            setElementOnClick(membershipManageButton, ()=>UIProfileSettingsController.handleSettingsClick(()=>UIProfileSettingsController.manageMembershipClickAction()));
            this.membershipStatusContainer.appendChild(membershipManageButton);
        }
    }
    static manageMembershipClickAction() {
        AudioManager.play(AudioType.Click);
        void UICheckoutAjaxEndPoints.executeStripeCustomerPortalSession();
    }
    showNotMemberTextAndBecomeMemberCTA() {
        const notMemberText = createParagraphIn(this.membershipStatusContainer, {
            key: 'strings:profilePage.settings.membership.dontHaveMemebership'
        }, '');
        const becomeMemberCTA = createLinkIn(this.membershipStatusContainer, '', {
            key: 'strings:profilePage.settings.membership.becomeMember'
        }, 'button_cta_main');
        setElementOnClick(becomeMemberCTA, ()=>UIProfileSettingsController.becomeMemberClickAction(), true);
        this.membershipStatusContainer.appendChild(notMemberText);
        this.membershipStatusContainer.appendChild(becomeMemberCTA);
    }
    static handleSettingsClick(action) {
        if (UIUtilsEjsVariables.isUserOnDiscord) {
            UIProfileSettingsController.showDiscordRedirectToWebDialog();
            return;
        }
        action();
    }
    static becomeMemberClickAction() {
        AudioManager.play(AudioType.Click);
        const eventData = {
            type: AnalyticEventType.ClickedStore,
            category: AnalyticEventCategory.Store
        };
        void CA.sendAnalyticEvent(eventData);
        if (isSubscriptionOverlayVariant()) uiManagerEvents.premiumMembershipCheckAction();
        else navigateToPage('/store#membership', undefined, true);
    }
    initAccountsSection() {
        UIProfileSettingsController.setConnectAccountButtonAction(this.googleButton, UIAPIEndpoints.googleLink());
        UIProfileSettingsController.setConnectAccountButtonAction(this.discordButton, UIAPIEndpoints.discordLink());
        UIProfileSettingsController.setConnectAccountButtonAction(this.appleButton, UIAPIEndpoints.appleLink());
    }
    setUserLoginState(loginState) {
        this.currentUserLoginState = loginState;
        this.setAccountEmailsIfAlreadyConnected();
    }
    setAccountEmailsIfAlreadyConnected() {
        for (const account of this.currentUserLoginState){
            const emailText = {
                key: 'strings:colonistCommon.utils.#buffer',
                options: {
                    value: account.email
                }
            };
            switch(account.providerId){
                case LoginProviderEnum.Google:
                    {
                        setElementInnerHTML(this.googleEmail, emailText);
                        this.googleEmail.classList.remove('hidden');
                        UIProfileSettingsController.setDisconnectAccountButtonAction(this.googleButton, UIAPIEndpoints.googleUnlink());
                        break;
                    }
                case LoginProviderEnum.Discord:
                    {
                        setElementInnerHTML(this.discordEmail, emailText);
                        this.discordEmail.classList.remove('hidden');
                        UIProfileSettingsController.setDisconnectAccountButtonAction(this.discordButton, UIAPIEndpoints.discordUnlink());
                        break;
                    }
                case LoginProviderEnum.Apple:
                    {
                        setElementInnerHTML(this.appleEmail, emailText);
                        this.appleEmail.classList.remove('hidden');
                        UIProfileSettingsController.setDisconnectAccountButtonAction(this.appleButton, UIAPIEndpoints.appleUnlink());
                        break;
                    }
            }
        }
    }
    static setConnectAccountButtonAction(element, apiLink) {
        setElementOnClick(element, ()=>UIProfileSettingsController.handleSettingsClick(()=>UIProfileSettingsController.handleConnect(apiLink)));
    }
    static setDisconnectAccountButtonAction(element, apiLink) {
        setElementOnClick(element, ()=>UIProfileSettingsController.handleSettingsClick(()=>UIProfileSettingsController.handleDisconnect(apiLink)));
        element.classList.add('disconnect');
        setElementInnerHTML(element, {
            key: 'strings:profilePage.settings.accounts.disconnect'
        });
    }
    static handleConnect(apiLink) {
        navigateToPage(apiLink);
    }
    static handleDisconnect(apiLink) {
        showSimpleDialog({
            title: {
                key: 'strings:profilePage.removeAccount.title'
            },
            body: {
                key: 'strings:profilePage.removeAccount.body'
            },
            onConfirm: ()=>void UIProfileSettingsController.unlinkProviderAndReload(apiLink),
            showCancelBtn: true
        });
    }
    static async unlinkProviderAndReload(apiLink) {
        const response = await UIAjaxWrapper.getRequestHandler(apiLink, undefined);
        if (response == undefined) return;
        location.reload();
    }
    static async checkIfUsernameMatchesInput(username, inputtedUsername) {
        if (username.toLowerCase() != inputtedUsername.toLocaleLowerCase()) {
            showSimpleDialog({
                title: {
                    key: 'strings:popups.errors.general.title'
                },
                body: {
                    key: 'strings:profilePage.deleteAccount.usernamesDontMatch'
                }
            });
            return;
        }
        const data = {
            username: inputtedUsername
        };
        const response = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiDeleteProfile(), undefined, data, 'application/json');
        if (response == undefined) return;
        StorageWrapper.clearUserState();
        tabCommunication.sendEvent(TabCommunicationEvent.ReloadWebsite);
        navigateToPage('/?account-deleted=1');
    }
    static showDeleteAccountPopup() {
        if (ClientUserState.userState == undefined) return;
        const username = ClientUserState.userState.username;
        showDeleteAccountDialog({
            username: username,
            onConfirm: (inputtedUsername)=>void UIProfileSettingsController.checkIfUsernameMatchesInput(username, inputtedUsername)
        });
    }
    static showDiscordRedirectToWebDialog() {
        var _ClientUserState_userState;
        const username = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.username;
        showSimpleDialog({
            title: {
                key: 'strings:popups.errors.discordRedirectToWeb.title'
            },
            body: {
                key: 'strings:popups.errors.discordRedirectToWeb.body'
            },
            confirmLabel: {
                key: 'strings:popups.errors.discordRedirectToWeb.cta'
            },
            onConfirm: ()=>navigateToPage(`https://colonist.io/profile/${username}#settings`, true)
        });
    }
    static handleLogout() {
        showSimpleDialog({
            title: {
                key: 'strings:homePage.header.logoutPopup.title'
            },
            body: {
                key: 'strings:homePage.header.logoutPopup.body'
            },
            onConfirm: async ()=>{
                const response = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.logout(), undefined, undefined);
                if (response == undefined) return;
                StorageWrapper.setUserBypassedLogin(false);
                StorageWrapper.clearUserState();
                navigateToPage(getHomepageUrl());
            },
            showCancelBtn: true
        });
    }
    constructor(){
        this.membershipStatusContainer = document.getElementById('membership-status-container');
        this.deleteAccountButton = document.getElementById('page-profile-settings-delete-account');
        this.logoutButton = document.getElementById('page-profile-settings-logout');
        setElementOnClick(this.deleteAccountButton, ()=>{
            if (UIUtilsEjsVariables.isUserOnDiscord) {
                UIProfileSettingsController.showDiscordRedirectToWebDialog();
                return;
            }
            UIProfileSettingsController.showDeleteAccountPopup();
        });
        if (this.logoutButton) setElementOnClick(this.logoutButton, ()=>UIProfileSettingsController.handleLogout());
        this.googleEmail = document.getElementById('page-profile-settings-account-email-google');
        this.discordEmail = document.getElementById('page-profile-settings-account-email-discord');
        this.appleEmail = document.getElementById('page-profile-settings-account-email-apple');
        this.googleButton = document.getElementById('page-profile-settings-account-button-google');
        this.discordButton = document.getElementById('page-profile-settings-account-button-discord');
        this.appleButton = document.getElementById('page-profile-settings-account-button-apple');
        const changeRegionButton = document.getElementById('page-profile-settings-change-region');
        setElementOnClick(changeRegionButton, ()=>showChangeRegionDialog());
        this.initMembershipStatus();
        this.initAccountsSection();
    }
}
